import { toast } from '@/components/toast';
import { CreateAvatarStoreUnion, RequestStatus, UploadFootageHandler } from '@/pages/avatar/common/types';
import { uploadFile } from '@/services/api';
import { logger } from '@/services/logger';
import createThumbnail, { ThumbnailResponseType } from '@/utils/thumbnail';
import axios from 'axios';
import { runInAction } from 'mobx';

const handleThumbnail = async (file: File, setUrl: (url: string) => void) => {
    try {
        const thumbnail = (await createThumbnail(file, ThumbnailResponseType.Blob)) as Blob;
        const thumbnailFile = new File([thumbnail], 'thumbnail.png', { type: 'image/jpeg' });
        const thumbnailUrl = await uploadFile(thumbnailFile as File, undefined, { s3Uri: false });
        setUrl(thumbnailUrl);
    } catch (error) {
        logger.error('failed to create thumbnail', error);
    }
};

const uploadFootage: UploadFootageHandler = async (
    file: File | null,
    setStatus: (status: RequestStatus) => void,
    setUrl: (url: string) => void,
    abortSignal: AbortSignal
) => {
    if (!file) {
        logger.error('Trying to upload a footage video without a file');
        return;
    }

    try {
        setStatus(RequestStatus.LOADING);
        const url = await uploadFile(file, abortSignal, { s3Uri: true });
        runInAction(() => {
            setUrl(url);
            setStatus(RequestStatus.SUCCESS);
        });
    } catch (error) {
        if (axios.isCancel(error)) {
            return;
        }

        setStatus(RequestStatus.ERROR);
        logger.error('Failed to upload video', error);
        toast.error({
            title: 'Failed to upload video, please try again',
        });
    }
};

export const handleFootage = async (store: CreateAvatarStoreUnion, abortSignal: AbortSignal) => {
    if (!store.footageFile) {
        logger.error('Trying to upload a footage video without a file');
        return;
    }

    await Promise.all([
        handleThumbnail(store.footageFile, store.setThumbnailUrl),
        uploadFootage(store.footageFile, store.setFootageUploadStatus, store.setFootageUrl, abortSignal),
    ]);
};
